import { Tooltip } from '@mui/material';
import React from 'react';

interface RenderWithOptionalTooltipProps {
  children: React.ReactNode;
  shoudShowTooltip: boolean;
  tooltipText: string;
  showArrow: boolean;
}

const RenderWithOptionalTooltip: React.FC<RenderWithOptionalTooltipProps> = ({
  children,
  shoudShowTooltip,
  tooltipText,
  showArrow
}) => {
  const validChildren = React.isValidElement(children) ? children : null;

  return shoudShowTooltip && validChildren ? (
    <Tooltip title={tooltipText} arrow={showArrow}>
      {validChildren}
    </Tooltip>
  ) : (
    <>{validChildren}</>
  );
};

export default RenderWithOptionalTooltip;
